<div class="card-body">
    <canvas #myChart></canvas>
</div>